export default (() => {

    $('.wedding-package .w-package-close').click(function() {
        var parent = $(this).parents('.wedding-package');

        if(parent.hasClass('open')) {
            parent.removeClass('open');
            return;
        }

        parent.addClass('open');
    })
});



// WEBPACK FOOTER //
// ./scripts/components/wedding-package.js